//по лейауту этот фал должен быть здесь, но по факту это не EDIT, это возврат денег - то есть удаление
import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { Flex, Input, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import { getTransactions, refundAction } from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const EditTransactions = ({
  transactionsModal,
  setTransactionsModal,
  clientInfo,
  transactionsInfo,
  payload,
}) => {
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);

  // STATE
  const [price, setPrice] = useState();

  // FUNCTIONS
  const onClickEditTransactions = () => {
    if (price === "") {
      openNotification({
        type: "error",
        message: `Поле "Комментарий" не может быть пустым`,
      });
    } else {
      dispatch(
        refundAction({
          flag: "post",
          value: {
            transactionId: transactionsInfo?.id,
            userId: clientInfo.id,
            amount: price,
          },
        })
      ).then(() => {
        openNotification({
          type: "success",
          message: `Сумма вычтена успешно`,
        });
        dispatch(getTransactions({ UserId: clientInfo?.id }));
        dispatch(getClientsList(payload));
        setTransactionsModal(false);
      });
    }
  };

  return (
    <CModal
      alignment="center"
      visible={transactionsModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setTransactionsModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Возврат средств"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Сумма возврата</Typography.Title>
              <Input
                defaultValue=""
                value={price}
                onChange={(event) => {
                  setPrice(event.target.value);
                }}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setTransactionsModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickEditTransactions} style={{ color: "#fff" }}>
          Оформить возврат
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default EditTransactions;
